<template>
  <b-container fluid class="profile-info animated fadeIn">
    <div v-show="errorText !== ''" class="alert alert-danger" role="alert" dismissible @dismised="errorText = ''">
      {{errorText}}
    </div>
    <div v-show="success" class="alert alert-success" role="alert" dismissible @dismised="success=false">
      La acción fue completada con éxito
    </div>
    <b-card>
      <user-form 
        ref="userForm"
        :user="user"
        :roleOptions="roleOptions"
        :allOrganizations="organizationOptions"
      />
      <b-row>
        <b-col class="px-4">
          <b-button class="mb-2 float-right" @click="resetUser">Reestablecer</b-button>
          <b-button
            class="mb-2 mr-2 float-right" @click="handleUpdateUser"
            :disabled="this.$refs.userForm ? this.$refs.userForm.disableSave : true"
          >Actualizar</b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row>
        <b-col>
          <h4>Contraseña</h4>
          <br />
          <b-col md="4" offset-md="4">
            <b-btn class="w-100" v-b-modal.pass-modal>Cambiar clave de acceso</b-btn>
          </b-col>
        </b-col>
      </b-row>
    </b-card>

    <b-modal id="pass-modal"
      centered
      title="Cambiar clave"
      ok-title="Cambiar"
      cancel-title="Cancelar"
      :ok-disabled="!(Boolean(password.old) && Boolean(password.newVal) && password.newVal.length > 5 && password.newVal === password.repeated)"
      @hidden="password={}"
      @ok="handleChangePassword">
      <b-container fluid class="mt-3 pw-info animated fadeIn">
        <b-col md="12">
          <b-form-group
            horizontal
            :label-cols="4"
            label="Clave actual"
          >
            <b-form-input type="password" v-model="password.old"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            horizontal
            :label-cols="4"
            label="Clave nueva"
            invalid-feedback="Debe contener al menos 6 caracteres"
            :state="!Boolean(password.newVal) || password.newVal.length > 5"
          >
            <b-form-input type="password" v-model="password.newVal"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            horizontal
            :label-cols="4"
            label="Repetir clave nueva"
            invalid-feedback="Las claves no coinciden"
            :state="!Boolean(password.repeated) || password.newVal === password.repeated"
          >
            <b-form-input type="password" v-model="password.repeated"></b-form-input>
          </b-form-group>
        </b-col>
      </b-container>
    </b-modal>
  </b-container>
</template>
<script>
import UserForm from '@/components/user/UserForm'
import { AdminServiceMixin, RoleService, OrganizationService } from '@/mixims/AdminServiceMixin'

export default {
  name: 'profile-view',
  mixins: [AdminServiceMixin, RoleService, OrganizationService],
  components: {
    UserForm
  },
  data () {
    return {
      errorText: '',
      success: false,
      password: {
        old: null,
        newVal: null,
        repeated: null
      },
      user: {...this.$store.state.user_data},
      roleOptions: [],
      organizationOptions: []
    }
  },
  mounted () {
    this.user = {...this.$store.state.user_data}
    this.user.organizations = this.$store.state.user_data.organizations
    let signedRoles = this.$store.getters.signedRoles
    let admin = signedRoles.includes('ADMIN_USER') || signedRoles.includes('ORGANIZATION_ADMIN_USER')
    if (admin) {
      this.getRoles().then(rs => {
        this.roleOptions = rs.body
      })
      this.getOrganizations().then(os => {
        this.organizationOptions = os.body
      })
    } else {
      this.roleOptions = this.$store.state.user_data.roles
      this.organizationOptions = [...this.$store.state.user_data.organizations]
    }
  },
  methods: {
    successed () {
      this.success = true
    },
    catchError (defaultMessage) {
      return er => {
        this.errorText = er.body.message || defaultMessage
      }
    },
    handleUpdateUser () {
      let self = this
      this.updateUser(this.user).then(() => {
        self.$store.dispatch('setUserData', self.user)
        self.successed()
      }).catch((er) => {
        console.log(er)
        this.errorText = 'Ocurrio un error, el usuario no se fue guardado'
      })
    },
    handleChangePassword () {
      this.changePassword(this.user.id, {
        code: this.password.old,
        password: this.password.newVal
      }).then(this.successed).catch(this.catchError('Ocurrio un error, el usuario no se fue guardado'))
    },
    resetUser () {
      this.user = {...this.$store.state.user_data}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ProfileView.vue